import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ViewController, NavParams } from 'ionic-angular';

import { Master  } from '@providers/asset/index';

@Component({
  selector: 'page-condition',
  templateUrl: 'page.html'
})
export class ConditionPage {

  List: any = [];
  pilihModal=0;

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.pilihModal = navParams.get('pilih');
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { };
    this.masterApi.getCondition(params).subscribe((resp:any) => {
      this.List = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  select(item){
    let data = { item: item };
    if(this.pilihModal==1){
      this.viewCtrl.dismiss(data);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/condition/page.ts